import $ from 'jquery'
import Swiper from 'swiper'

export default () => {
  $(() => {
    if (!$('body').hasClass('single-project')) return

    new Swiper('.related-projects .projects.swiper-container', {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 8,
      navigation: {
        nextEl: '.related-projects .swiper-button-next',
        prevEl: '.related-projects .swiper-button-prev',
      },
    })
  })

  const gallerySwiper = new Swiper('.project-gallery .swiper-container', {
    navigation: {
      nextEl: '.project-gallery .swiper-button-next',
      prevEl: '.project-gallery .swiper-button-prev',
    },
    pagination: {
      el: '.project-gallery .swiper-pagination',
      type: 'custom',
      renderCustom: function(swiper, current, total) {
        let html = ''
        swiper.slides.map((slide, index) => {
          const bgUrl = $(slide).find('img').attr('src')
          html += `<span class="swiper-pagination-custom" index="${index}"><img src="${bgUrl}" /></span>`
        })
        return html
      }
    }
  })

  $(document).on('click', '.project-gallery .swiper-pagination .swiper-pagination-custom', e => {
    e.preventDefault()
    const $container = $(e.target).closest('.swiper-pagination-custom')
    gallerySwiper.slideTo($container.attr('index'))
  })
}
